<template>
  <el-drawer
    :title="$t('system::common::editorHeader-table::title')"
    custom-class="edit_table_header"
    size="440px"
    :visible.sync="drawer"
    :direction="direction"
    :modal="false"
    append-to-body
    :modal-append-to-body="false"
  >
    <div class="edit_table_header_body">
      <div class="edit_table_header_tip">{{ $t('system::common::editorHeader-table::tip') }}</div>
      <div class="edit_table_header_drag">
        <draggable-list
          :list="activeList"
          :textlist="columns"
          :fixTableHeaderList="fixTableHeaderList"
        ></draggable-list>
      </div>
      <div class="table_header_action">
        <el-checkbox style="margin-bottom: 0" v-model="allColumnConfig" @input="changeAllCheck">
          {{ $t('system::common::btn::selecAll') }}
        </el-checkbox>
        <div>
          <el-button size="small" @click="resetOriginColumnConfig">
            {{ $t('system::common::btn::reset') }}
          </el-button>
          <el-button size="small" type="primary" @click="confirmColumnConfig">
            {{ $t('system::common::btn::confirm') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import DraggableList from './draggable-list.vue'
import { getColumnConfig, saveColumnConfig } from '@/server/common'
export default {
  components: { DraggableList },
  props: {
    direction: {
      default: 'rtl',
      type: String,
    },
    value: {},
    fixTableHeaderList: {
      default: () => [],
      type: Array,
    },
    list: {
      default: () => [],
      type: Array,
    },
    columns: {
      default: () => [],
      type: Array,
    },
    info: {
      // name 缓存的表头名， limit 至少要保存几个表头
      default: () => ({ name: '', limit: 4 }),
      type: Object,
    },
  },
  data() {
    return {
      drawer: false,
      allColumnConfig: false,
      activeList: [],
    }
  },
  watch: {
    value(val) {
      this.drawer = val
      if (val) {
        this.activeList = JSON.parse(JSON.stringify(this.list))
      }
    },
    drawer(val) {
      this.$emit('input', val)
    },
    activeList: {
      handler(val) {
        this.allColumnConfig = this.activeList.every(el => el.active)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    changeAllCheck(v) {
      this.activeList.forEach(config => {
        if (this.fixTableHeaderList.includes(config.prop)) {
          this.$set(config, 'active', true)
        } else {
          this.$set(config, 'active', v)
        }
      })
    },
    // 重置为上次设置表头
    resetOriginColumnConfig() {
      this.activeList = JSON.parse(JSON.stringify(this.list))
    },
    async confirmColumnConfig() {
      if (this.activeList.filter(el => el.active).length < this.info.limit) {
        return this.$message.error(this.$t('system::common::editorHeader::errorTip', { limit: this.info.limit }))
      }
      const postData = {
        tableName: this.info.name,
        columns: JSON.stringify(this.activeList),
      }
      // 保存同步表头数据接口
      const { data } = await saveColumnConfig(postData)
      if (data.code === 0) {
        this.$emit('change', { name: this.info.name, list: this.activeList })
      }
      this.drawer = false
    },
  },
}
</script>

<style scoped lang="scss">
/deep/ .el-drawer__header {
  color: #010517;
  border-bottom: 1px solid rgba(214, 218, 224, 0.5);
  padding: 16px;
  margin-bottom: 0;
}
.edit_table_header {
  outline: none;
  .edit_table_header_tip {
    margin-top: 16px;
    color: #999;
    padding: 0 16px;
  }
  .edit_table_header_drag {
    padding: 0 16px 63px;
  }
  .table_header_action {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    right: 0;
    height: 63px;
    border-top: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 440px;
    box-sizing: border-box;
    z-index: 999;
  }
}
</style>
